import Button from "./Button";
import PropTypes from "prop-types";
import RadioButtonInner from "./RadioButtonInner";
import React from "react";

function RadioButton({ active, label, onClick }) {
  return (
    <Button onClick={onClick} aria-label={label}>
      <RadioButtonInner active={active} label={label} />
    </Button>
  );
}

export default RadioButton;

RadioButton.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
